import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PageHeader({ title, showBack = false, right }) {
  const navigate = useNavigate();

  return (
    <div className="page-header flex items-center justify-between">
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            className="w-8 h-8 flex items-center justify-center rounded-xl transition-colors"
            style={{ background: 'rgba(255,255,255,0.08)' }}
          >
            <ArrowLeft size={16} className="text-white" />
          </button>
        )}
        <h1 className="font-serif font-semibold text-lg text-white">{title}</h1>
      </div>
      {right && <div>{right}</div>}
    </div>
  );
}
